import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import { useForm } from 'react-hook-form';
import { Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Row, Spinner } from 'reactstrap';
import { Map, TileLayer, GeoJSON } from 'react-leaflet'
import toGeoJSON from 'togeojson';

//Services
import { api_GET, api_POST, api_PUT } from '../../../services/api_service';
import { showMessage } from '../../../services/message';


// style
import "../../../assets/css/map.css";

function DelimitacaoGeograficaSetoresForm({ history, handleReturn, item }) {

    const { register, handleSubmit, errors, setError, setValue } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = useState(false);

    //Estado de controle do centro do geojson
    const [centerGeoJson, setCenterGeoJson] = useState([-3.755019499914185, -38.5860013961792]);

    const [geoJson, setGeoJson] = useState(null);

    const [optionsModalidadesColeta, setoptionsModalidadesColeta] = React.useState([]);
    const [modalidadesColeta, setModalidadesColeta] = React.useState(null);
    const loadOptionsModalidadesColeta = () => {
        setshowLoading(true)
        api_GET(`modalidadeColeta`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setoptionsModalidadesColeta(result.data);
            }
        });
        setshowLoading(false);
    }

    const handleModalidadesColeta = (value) => {
        setModalidadesColeta(value.modalidadeColetaId)
    }

    const loadDelimitacaoGeografica = () => {
        setModalidadesColeta(item.modalidadeColetaId)
        setValue("modalidadeId", item.modalidadeColetaId);
        setValue("codigo", item.descricao);

        if (item?.geoJson) {
            let _geojson = JSON.parse(item.geoJson);
            setGeoJson(_geojson);
            if(_geojson.features?.length > 0){
                if (_geojson.features[0]?.geometry.coordinates[0][0][1] && _geojson.features[0]?.geometry.coordinates[0][0][0])
                    setCenterGeoJson([_geojson.features[0]?.geometry.coordinates[0][0][1], _geojson.features[0]?.geometry.coordinates[0][0][0]]);
                else
                    setCenterGeoJson([_geojson.features[0]?.geometry.coordinates[0][1], _geojson.features[0]?.geometry.coordinates[0][0]]);
            }else {
                setCenterGeoJson([_geojson.geometry?.coordinates[0][1], _geojson.geometry.coordinates[0][0]]);
            }
        }
    }

    useEffect(() => {
        loadOptionsModalidadesColeta();
        if (item) {
            loadDelimitacaoGeografica();
        }
    }, []);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const kmlText = e.target.result;
                const kmlDOM = new DOMParser().parseFromString(kmlText, 'text/xml');
                const newGeojson = toGeoJSON.kml(kmlDOM);

                if (newGeojson?.features?.length > 1) {
                    showMessage("Aviso", "Um arquivo .KML só deve conter uma única localização dentro dele", 'warning', null);
                } else {
                    setGeoJson(newGeojson);

                    if (newGeojson.features[0]?.geometry.coordinates[0][0][1] && newGeojson.features[0]?.geometry.coordinates[0][0][0])
                        setCenterGeoJson([newGeojson.features[0]?.geometry.coordinates[0][0][1], newGeojson.features[0]?.geometry.coordinates[0][0][0]]);
                    else
                        setCenterGeoJson([newGeojson.features[0]?.geometry.coordinates[0][1], newGeojson.features[0]?.geometry.coordinates[0][0]]);
                }
            };
            reader.readAsText(file);
        }
    };

    const onSubmit = (data) => {
        if (modalidadesColeta == null) {
            showMessage("Aviso", "Selecione a modalidade de coleta, por favor.", "warning", null);
            return;
        }

        let json_submit = {
            id: item == null ? 0 : item.id,
            descricao: data.codigo,
            geoJson: geoJson == null ? null : JSON.stringify(geoJson),
            modalidadeColetaId: modalidadesColeta
        }

        setshowLoading(true);
        if (item == null) {
            api_POST('DelimitacaoGeograficaSetor', json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                        handleReturn();
                    });
                }
            });
        }
        else {
            api_PUT('DelimitacaoGeograficaSetor', json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                        handleReturn();
                    });
                }
            });
        }
    }

    return <>
        {showLoading &&
            <div className="carregandoCmp" style={{ zIndex: 9999999 }}>
                <div className="box">
                    <label style={{ marginRight: "20px" }}>Carregando...</label>
                    <Spinner size="sm" color="info" />
                </div>
            </div>
        }

        <Row>
            <Container fluid>
                <Card className="shadow">
                    <CardHeader className="border-0">
                        <strong> Cadastro de Setor</strong>
                    </CardHeader>
                    <CardBody>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Row>
                                <Col md="6" lg="4">
                                    <FormGroup>
                                        <label className="form-control-label"  >
                                            * Código
                                        </label>
                                        <Input
                                            name="codigo"
                                            placeholder="Digite o Código"
                                            type="text"
                                            maxLength={200}
                                            innerRef={register({ required: true })}
                                        />
                                        {errors.codigo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="4" lg="4" style={{ zIndex: 99999 }}>
                                    <FormGroup >
                                        <label className="form-control-label">
                                            * Modalidades de Serviço
                                        </label>
                                        <Select
                                            options={optionsModalidadesColeta}
                                            name="modalidadeColetaId"
                                            getOptionLabel={({ descricao }) => descricao}
                                            getOptionValue={({ modalidadeColetaId }) => modalidadeColetaId}
                                            onChange={(value) => { handleModalidadesColeta(value) }}
                                            value={modalidadesColeta ? optionsModalidadesColeta.filter(x => x.modalidadeColetaId == modalidadesColeta)[0] : null}
                                            placeholder="Selecione"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4" lg="4">
                                    <FormGroup>
                                        <label className="form-control-label">
                                            Arquivo Kml
                                        </label>
                                        <Input
                                            type="file"
                                            accept=".kml"
                                            maxLength={200}
                                            onChange={handleFileChange}
                                            innerRef={register()}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <div id="map">
                                        <Map
                                            center={centerGeoJson}
                                            zoom={14}
                                        >
                                            <TileLayer
                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                            />
                                            {geoJson != null &&
                                                <GeoJSON data={geoJson} key={JSON.stringify(geoJson)} />
                                            }
                                        </Map>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12" className="text-center">
                                    <label className="form-control-label"></label>
                                    <FormGroup>
                                        <Button color="warning" type="button" onClick={() => handleReturn()}>Voltar</Button>
                                        <Button color="success">Salvar</Button>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </form>
                    </CardBody>
                </Card>
            </Container>
        </Row>
    </>;
}

export default DelimitacaoGeograficaSetoresForm;